import React, { useState } from 'react';
import { App, Button, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { getOrderSummaryApi } from 'api/hallazgoFlujo';
import { getOrderDocumentDataApi, getOrderStaticDatagApi } from 'api/budget';
import { getAccessTokenApi } from 'api/auth';
import PDFOrderContainer from 'PDF/Order/PDFOrderContainer';

function DownloadOrderButton({ idOrder, size = 'middle' }) {
  const { notification } = App.useApp();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!idOrder) return;
    setLoading(true);
    try {
      const token = getAccessTokenApi();
      // El endpoint de document-data es by-idBudget, no by-idOrder — primero
      // resolvemos el idBudget desde el summary de la ODT.
      const summary = await getOrderSummaryApi(idOrder);
      if (!summary?.id || !summary.id_budget) {
        notification.error({
          message: 'No se pudo cargar la ODT',
          description: summary?.message || undefined,
        });
        return;
      }
      const idBudget = summary.id_budget;
      const [docData, staticData] = await Promise.all([
        getOrderDocumentDataApi(token, idBudget),
        getOrderStaticDatagApi(token),
      ]);
      // Response shape: { state, message, order: { order, items } }. En
      // warning backend devuelve order: {} (truthy) — chequear por el
      // order interno o state.
      if (docData?.state !== 'success' || !docData.order?.order) {
        notification.error({
          message: 'No se pudieron cargar los datos de la ODT',
          description: docData?.message || undefined,
        });
        return;
      }
      const config = staticData?.tenant || {};
      notification.open({
        message: `Descargar ODT #${summary.id}`,
        btn: <PDFOrderContainer idBudget={idBudget} config={config} data={docData.order} />,
        duration: 0,
      });
    } catch (err) {
      notification.error({ message: err?.message || 'Error al cargar' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Tooltip title="Descargar PDF">
      <Button size={size} icon={<DownloadOutlined />} loading={loading} onClick={handleClick} />
    </Tooltip>
  );
}

export default DownloadOrderButton;
